<template>
    <div :class="[isMobile ? 'ans-facet-full' : 'ans-facet-sidebar', 'alignement-facet-container']">
        <div v-if="store.alignementsList.length > 0" class="panel panel-default facet-bloc">
            <div class="panel-heading">
                <h6 class="panel-title">
                    <strong>Alignements</strong>
                </h6>
            </div>
            <div class="panel-body">
                <div v-if="store.numberOfConceptsWithAlignement > 0" class="text-center">
                    <small class="text-muted">{{ store.numberOfConceptsWithAlignement }} concepts trouvés</small>
                </div>
                <div>
                    <button class="check-uncheck-btn btn btn-link btn-sm" type="button"
                        @click="checkOrUnCheckAllAlignements()">
                        {{ checkOrUnCheckAllAlignementsText }}
                    </button>
                </div>

                <AlignementFacetTree :items="store.alignementFacets.options.all" :parentPrefix="'align-parent-'"
                    :childPrefix="'align-child-'" :singlePrefix="'align-single-'" :itemKey="item => item.UUID"
                    @toggle-selection="toggleSelection" />
            </div>
        </div>
    </div>
</template>

<script>
import ConceptsStore from "../concepts-store";
import AlignementFacetTree from "./AlignementFacetTree";

export default {
    name: "AlignementFacet",
    components: { AlignementFacetTree },

    data() {
        return {
            store: ConceptsStore.state,
            cbSelectAll: false,
        };
    },

    created() {
    },

    computed: {
        checkOrUnCheckAllAlignementsText() {
            return this.cbSelectAll ? "Tout désélectionner" : "Tout sélectionner";
        },

        isMobile() {
            return window.innerWidth < 768;
        }
    },

    methods: {
        checkOrUnCheckAllAlignements() {
            this.cbSelectAll = !this.cbSelectAll;

            for (const option of this.store.alignementFacets.options.all) {
                option.checked = this.cbSelectAll;
            }

            this.$emit('alignement-facets-changed');
        },

        toggleSelection(item) {
            item.checked = !item.checked;
            this.cbSelectAll = this.store.alignementFacets.options.all.length > 0
                && this.store.alignementFacets.options.all.every(option => option.checked);

            this.$emit('alignement-facets-changed');
        },
    }
};
</script>

<style lang="scss" scoped>
.alignement-facet-container {
    margin-bottom: 20px;
}

.ans-facet-full {
    position: fixed;
    width: 95%;
    z-index: 9999;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.facet-bloc {
    margin-bottom: 20px;
    background-color: #FFFFFF;
    border: 1px solid #e0e0e0;
    border-radius: 4px;

    &:last-child {
        margin-bottom: 0;
    }

    .panel-heading {
        background-color: #1D71B8;
        border-bottom: 1px solid #dee2e6;
        text-align: center;
        padding: 15px 10px;

        .panel-title {
            color: #FFFFFF;
            margin: 0;
            font-size: 18px;
        }
    }

    .panel-body {
        max-height: 30rem;
        overflow: auto;
        padding: 10px;
        background-color: #FFFFFF;
    }
}

@media (max-width: 767.98px) {
    .alignement-facet-container {
        width: 100%;
        position: static;
    }

    .ans-facet-full {
        width: 100%;
        position: static;
        transform: none;
        left: auto;
        top: auto;
        z-index: auto;
        overflow-y: visible;
    }

    .facet-bloc {
        margin-bottom: 15px;
    }

    .panel-body {
        max-height: none;
        overflow-y: visible;
    }
}

@media (min-width: 768px) and (max-width: 991.98px) {
    .ans-facet-sidebar {
        position: static;
        margin-bottom: 1rem;
    }

    .panel-body {
        max-height: none;
        overflow-y: visible;
    }
}
</style>